import { AspectRatioName } from "./AspectRatioName";
import { LocationNames } from "./LocationName";
import DaypartingField from "./DaypartingField";

type ArrayValueProps = {
  value: string;
  fieldPath: string;
};

export const ArrayValue = ({ value, fieldPath }: ArrayValueProps) => {
  let items: string[] | Array<{ dayIndex: number; slots: string[] }> = [];

  try {
    items = JSON.parse(value);
  } catch {
    return <span>{value}</span>;
  }

  if (!Array.isArray(items) || items.length === 0) {
    return <span>{value}</span>;
  }

  const isGeoField = /geoCriteria\/(whitelist|blacklist)/.test(fieldPath);
  const isDaypartingField = /dayparting/.test(fieldPath);
  const isAspectRatioField = /aspectRatios\/values/.test(fieldPath);

  if (isAspectRatioField) {
    return (
      <span>
        {items.map((item, index) => (
          <span key={item}>
            <AspectRatioName value={item} />
            {index < items.length - 1 ? ", " : ""}
          </span>
        ))}
      </span>
    );
  }

  if (isGeoField) {
    return <LocationNames locationIds={items as string[]} />;
  }

  if (isDaypartingField) {
    return (
      <DaypartingField
        items={items}
        fieldPath={fieldPath}
      />
    );
  }

  return <span>{items.join(", ")}</span>;
};
